module.exports = __webpack_public_path__ + "img/success@2x.d7448c6c.png";